import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { UserAuthenticationService } from '../../../../../../libs/administration/src/lib/services/user-authentication.service';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
class ProtectedGuardService {
  constructor(
    private _router: Router,
    private _authService: UserAuthenticationService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this._authService.isLogin()) {
      return true;
    } else {
      const returnUrl = state.url;
      if (returnUrl && returnUrl !== '/' && !returnUrl.startsWith('/?')) {
        this._router.navigate(['/'], { queryParams: { returnUrl } });
      } else {
        this._router.navigateByUrl('/');
      }
      return false;
    }
  }
}

export const ProtectedGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(ProtectedGuardService).canActivate(next, state);
};
